/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { ToolkitGestioneRilievoTabAnagraficaRilievoComponent } from './tab-anagrafica-rilievo/tab-anagrafica-rilievo.component';
import { ToolkitGestioneRilievoTabOpereAssociateComponent } from './tab-opere-associate/tab-opere-associate.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        NgbModule
    ],
    declarations: [
        ToolkitGestioneRilievoTabAnagraficaRilievoComponent,
        ToolkitGestioneRilievoTabOpereAssociateComponent
    ],
    exports: [
        ToolkitGestioneRilievoTabAnagraficaRilievoComponent,
        ToolkitGestioneRilievoTabOpereAssociateComponent
    ],
    entryComponents: [ ],
})
export class PagesGestioneRilievoToolkitModule { }
